import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import './style.scss';

/**
 * Component that displays a reports selector.
 *
 * @returns {JSX.Element} The ReportsSelector component.
 * @example
 *  <ReportsSelector />
 */
function ReportsSelector() {
  const { t } = useTranslation();
  const history = useHistory();
  const [popoverVisible, setPopoverVisible] = useState(false);

  /**
   * Navigate to the selected report tab.
   * @param {string} tab - Report tab: 'fit' or 'inactivation'.
   */
  const handleNavigate = (tab) => {
    history.push(`/reports/${tab}`);
    setPopoverVisible(false);
  };

  const content = (
    <div className="align-translation">
      <Button
        type='default'
        onClick={() => handleNavigate('fit')}
        tabIndex={0}
      >
        {t('reportsTitle.fit')}
      </Button>
      <Button
        type='default'
        onClick={() => handleNavigate('inactivation')}
        tabIndex={0}
      >
        {t('reportsTitle.inactivation')}
      </Button>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      visible={popoverVisible}
      onVisibleChange={setPopoverVisible}
      overlayClassName="popover-overlay"
    >
      <span tabIndex={0} role="button" className="reports-selector__trigger">
        {t('reportsTitle.menu')}
      </span>
    </Popover>
  );
}

export default ReportsSelector;
